export class CustomFormControl {
    constructor(
        public label?: string,
        public Name?: string,
        public Mandotory?: boolean,
        public HtmlElementType?: string,
        public value?: any,
        public Multiple?: boolean,
        public Dropdown?: boolean,
        public CustomInput?: boolean,
        public Options?: Array<{ text: string, value: string }>
    ) {
        this.Mandotory = false;
        this.Dropdown = false;
        this.CustomInput = false;
        this.Options = [];
    }
}